import { Component, OnInit } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router,ActivatedRoute  } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import * as $ from 'jquery';
import xml2js from 'xml2js';
declare var show_okshan_alert: Function;
declare var show_okshan_alert3: Function;
declare var manage_show_hide_inspection_detail: Function;
declare var show_img: Function;
declare var show_img2: Function;

@Component({
  selector: 'app-fixed-price-car-seller-acceptance-detail',
  templateUrl: './fixed-price-car-seller-acceptance-detail.component.html',
  styleUrls: ['./fixed-price-car-seller-acceptance-detail.component.css']
})
export class FixedPriceCarSellerAcceptanceDetailComponent implements OnInit {
  fileUrl; 
  id;
  carMakeOfferListCarDetail;
  sessionId;
  actionStatus:boolean=false;
  sessionProfileType:number;

  constructor(private httpserviceService:HttpserviceService,private sessionsService:SessionsService,private router:Router,private _constant: ConstantsService,private route:ActivatedRoute) { }

  ngOnInit(): void { 
    if(this.sessionsService.getSession("login_status")==null)
    {       
      window.location.href="#/visitor";       
    } else if(!this.sessionsService.getSession("login_status")) {
      window.location.href="#/visitor";
    }
    window.scrollTo(0, 0);
    this.sessionId=this.sessionsService.getSession("id");
    if(this.sessionsService.getSession("profile_type")!=null && this.sessionsService.getSession("status")!=null)
    {
       if(this.sessionsService.getSession("profile_type")!=-1 && this.sessionsService.getSession("status")==1)
       {
         this.actionStatus=true;
       }
    }
    if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    this.id=this.route.snapshot.queryParamMap.get('id');
    this.fileUrl=this._constant.uploadFileUrl;
      setTimeout(() => {
        this.getCarMakeOfferListCarDetail();
      }, 50);
    setTimeout(() => {
      manage_show_hide_inspection_detail();
    }, 1000);  
  }

  /** Accept Offer function used to get all accepted  cars list  */
  getAcceptOfferCarsList(id, userId, acceptValue)
  {
    let result =this.httpserviceService.getAcceptOfferCarsRequest(id, userId, acceptValue).
     pipe(retry(0)).
     subscribe((data)=>this.getAcceptOfferCarsListResponse(data),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** getAcceptOfferCarsListResponse function used to handle response */
  getAcceptOfferCarsListResponse(response)
  {
    console.log('getAcceptOfferCarsListResponse '+ response);
    if(response.status==="success")  
     {       
        location.reload();         
     }
     else
     {
        show_okshan_alert(response.reason);
     } 
  }

  /** getViewAcceptOfferCarsListConfirmation function used to open view accept offers car list for confirmation */
  getViewAcceptOfferCarsListConfirmation(id, userId, seller_acceptance)
  {
    if(seller_acceptance == 0) {
        if (confirm("Are you sure you want to Accept this offer?"))
        {
          this.getAcceptOfferCarsList(id, userId, 1);
        }
    } else {
      if (confirm("Are you sure you want to Non Accept this offer?"))
      {
         this.getAcceptOfferCarsList(id, userId, 0);
      }
    }
  }


  /** getCarMakeOfferListCarDetail function used to get car make a offer  */
  getCarMakeOfferListCarDetail()
  {
     var carId = this.router.url.split("=").pop();
     let result =this.httpserviceService.makeOfferListRequest(carId).
     pipe(retry(0)).
     subscribe((data)=>this.carMakeOfferListCarDetailResponse(data),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** carMakeOfferListCarDetailResponse function used to handle response */
  carMakeOfferListCarDetailResponse(response)
  {
    console.log('carListResponse '+ response);
    if(response.status==="success")  
     {       
        this.carMakeOfferListCarDetail=response.list;
     }
     else
     {
        show_okshan_alert(response.reason);
     } 
  }
}

